import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

/**
 * Formats a job's startTime for the header label without routing through DatePipe.
 * Accepts a numeric ms timestamp, Date, or a pre-formatted app string
 * (D-MMM-YY, hh:mm:ss A [zone abbr]). Bare ISO strings are not parsed and are
 * returned unchanged.
 */
@Pipe({ name: 'jobHeaderDate' })
export class JobHeaderDatePipe implements PipeTransform {
  transform(
    startTime: string | number | Date | null | undefined,
    timeZone = 'UTC',
    timeFormat = 'D-MMM-YY, hh:mm:ss A z',
    localeId = 'en-US'
  ): string {
    if (startTime == null || startTime === '') {
      return '';
    }

    const zone = timeZone || 'UTC';
    let parsedMoment: moment.Moment;

    if (typeof startTime === 'number' || startTime instanceof Date) {
      // Same path as getValueFromExp() for numeric epochs
      parsedMoment = moment(startTime).tz(zone);
    } else {
      // Pre-formatted strings like "28-Jul-26, 09:09:21 AM IST" — strip the abbr and
      // parse as wall time in timeZone (the string was produced via .tz(timeZone)).
      const formatNoZone = (timeFormat || 'D-MMM-YY, hh:mm:ss A z').replace(/\s*z\s*$/i, '').trim();
      const withoutZone = String(startTime).replace(/\s+(?:[A-Za-z]{2,5}|[+-]\d{2}(?::?\d{2})?)$/, '').trim();
      parsedMoment = moment.tz(withoutZone, formatNoZone, true, zone);
    }

    if (!parsedMoment.isValid()) {
      return String(startTime);
    }

    // Pass the zone offset so formatDate doesn't re-interpret in browser-local time
    return formatDate(parsedMoment.toDate(), 'fullDate', localeId, parsedMoment.format('Z'));
  }
}
